import { create } from 'zustand'

interface LayoutState {
  hideShell: boolean
  setHideShell: (hide: boolean) => void
}

export const useLayoutStore = create<LayoutState>((set) => ({
  hideShell: false,
  setHideShell: (hide) => set({ hideShell: hide }),
}))
